<template>
  <canvas :height="height" :width="width" id="financements-percus-total-graph"></canvas>
</template>
<script>
import {SOLUTIA} from "@/constants/Colors";
import {Chart} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {arrondirKeurosAsNumber} from "@/util";

export default {
  name: "FinancementsPercusTotalGraph",
  props: {
    data: Array,
    height: {
      type: Number,
      default: 600,
    },
    width: {
      type: Number,
      default: 600,
    }
  },
  mounted: async function () {
    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    // eslint-disable-next-line no-unused-vars
    const chartData = {
      label: "Financements perçus totaux",
      labels: this.data.map(data_of_year => data_of_year.year),
      datasets: [
        {
          label: "TOTAL Financement Perçus DEAL",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_paye_deal / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[0]
        },
        {
          label: "TOTAL Financement Perçus CTM",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_paye_ctm / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[1]
        },
        {
          label: "TOTAL Financements Perçus Bénéficiaires",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_paye_beneficiaire / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[2]
        },
        {
          label: "TOTAL",
          tooltip: {
            enabled: false
          },
          data: this.data.map(function (data_of_year) {
            return arrondirKeurosAsNumber(data_of_year.total_percu / 20);
          }),
          datalabels: {
            color: 'black',
            clamp: true,
            anchor: "end",
            formatter: function (value, context) {
              let total = Math.round(that.data[context.dataIndex].total_percu / 1000);
              console.log(`debugDatalabels : ${context.dataIndex} - ${that.data[context.dataIndex].total_percu} - ${total}`)
              return total.toString();
            },
            font: {
              size: 16,
              weight: "bold"
            }
          },
          backgroundColor: "#ffffff00"
        },
      ],
    }
    // eslint-disable-next-line no-unused-vars
    const config = {
      title: {
        display: true,
        text: "Financements perçus totaux",
        fontSize: 16,
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false,
          }
        }]
      },

    }
    let that = this;
    this.$nextTick(function () {
      const ctx = document.getElementById('financements-percus-total-graph');
      that.chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        //...defaultData
        data: chartData,
        options: config,
      });
    })
  },
  data: function () {
    return {
      chart: null
    }
  },
  computed: {
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
  },
  methods: {}
}
</script>

<style scoped>

</style>